const STORAGE_PREFIX = 'bg-recent-games-'
const MAX_RECENT_GAMES = 10

function storageKey (loginId) {
  const id = String(loginId || '').trim()
  if (!id) return ''
  return STORAGE_PREFIX + id
}

function readList (loginId) {
  const key = storageKey(loginId)
  if (!key || typeof window === 'undefined') return []
  try {
    const raw = window.localStorage.getItem(key)
    const parsed = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed : []
  } catch (err) {
    return []
  }
}

function writeList (loginId, list) {
  const key = storageKey(loginId)
  if (!key || typeof window === 'undefined') return
  try {
    window.localStorage.setItem(key, JSON.stringify(list))
  } catch (err) {
    // quota exceeded 등은 무시
  }
}

export function buildRecentGameKey (entry) {
  if (!entry) return ''
  const provider = Number(entry.provider)
  const code = String(entry.code || '')
  const category = Number(entry.category)
  const vendorId = entry.vendor_id != null ? Number(entry.vendor_id) : -1
  return [provider, code, category, vendorId].join(':')
}

export function createRecentGameEntry ({
  game = null,
  provider,
  code,
  category,
  vendorId = -1,
  title = ''
} = {}) {
  const source = game && typeof game === 'object' ? game : {}
  const resolvedVendorId = source.vendor_id != null
    ? Number(source.vendor_id)
    : Number(vendorId)

  return {
    provider: Number(source.provider != null ? source.provider : provider),
    code: String(source.code != null ? source.code : code || ''),
    category: Number(source.category != null ? source.category : category),
    vendor_id: Number.isFinite(resolvedVendorId) ? resolvedVendorId : -1,
    name: String(source.name || title || source.code || code || '').trim(),
    provider_name: String(source.provider_name || source.providerLabel || '').trim(),
    image: String(source.image || '').trim(),
    playedAt: Date.now()
  }
}

export function normalizeRecentGames (list) {
  if (!Array.isArray(list)) return []
  return list
    .filter(item => item && item.provider != null && item.code)
    .map(item => ({
      provider: Number(item.provider),
      provider_name: item.provider_name || '',
      code: String(item.code),
      name: item.name || item.code,
      image: item.image || '',
      category: item.category != null ? Number(item.category) : undefined,
      vendor_id: item.vendor_id != null ? Number(item.vendor_id) : -1,
      is_hot: false,
      playedAt: Number(item.playedAt) || 0
    }))
}

export function getRecentGames (loginId) {
  return normalizeRecentGames(readList(loginId))
    .sort((a, b) => (b.playedAt || 0) - (a.playedAt || 0))
    .slice(0, MAX_RECENT_GAMES)
}

export function recordRecentGame (loginId, entry) {
  const key = storageKey(loginId)
  if (!key || !entry) return []

  const normalized = createRecentGameEntry(entry)
  if (!normalized.provider || !normalized.code) return getRecentGames(loginId)

  const dedupeKey = buildRecentGameKey(normalized)
  const next = readList(loginId)
    .filter(item => buildRecentGameKey(item) !== dedupeKey)

  next.unshift(normalized)
  writeList(loginId, next.slice(0, MAX_RECENT_GAMES))
  return getRecentGames(loginId)
}
